import {
    Button,
    ButtonGroup,
    CheckboxWithLabel, DialogBody,
    DialogContainer,
    DialogFooter,
    DialogHeader,
    Message
} from '@wg/wows-react-uikit'
import { t } from 'helpers/localization'
import filter from 'lodash/filter'
import get from 'lodash/get'
import React, { PureComponent } from 'react'
import { LANGUAGES } from '../../../constants'
import styles from './LanguagesDialog.scss'

export interface LanguagesDialog_Props {
    isOpen: boolean,
    languagesMap: any,
    hideDialog: () => void,
    updateLanguages: (languages: Array<String>) => void,
}

class LanguagesDialog extends PureComponent<LanguagesDialog_Props, any> {

    constructor(props) {
        super(props)

        this.state = {
            languagesMap: props.languagesMap,
            isLanguageNotSelected: false,
        }

        this.languageChanged = this.languageChanged.bind(this)
        this.updateLanguages = this.updateLanguages.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps: LanguagesDialog_Props, nextContext){
        this.setState({...this.state, languagesMap: nextProps.languagesMap})
    }

    getSelectedLanguages() {
        let languages = Object.entries(this.state.languagesMap)
        languages = Object.values(filter(languages, ([key, value]) => value === true))
        return languages.map(([languageCode, language]) => languageCode)
    }

    languageChanged(languageCode) {
        return () => {

            const languagesMap = {
                ...this.state.languagesMap,
                [languageCode]: !get(this.state.languagesMap, languageCode, false),
            }

            const isLanguageNotSelected = filter(Object.values(languagesMap)).length === 0

            this.setState({
                ...this.state,
                languagesMap,
                isLanguageNotSelected,
            })
        }
    }

    updateLanguages() {
        this.props.updateLanguages(this.getSelectedLanguages())
        this.props.hideDialog()
    }

    render() {
        let content = Object.entries(this.props.languagesMap).map(
            ([languageCode]) => (
                <div key={languageCode} className={styles.language}>
                    <CheckboxWithLabel
                        labelText={get(LANGUAGES, languageCode, `[ ${languageCode} ]`)}
                        isChecked={get(this.state.languagesMap, languageCode, false)}
                        onChange={this.languageChanged(languageCode)} />
                </div>
            )
        )

        const languageNotSelectedMessage = this.state.isLanguageNotSelected
            ? (<Message type="error" style="inline">{t('Язык не выбран')}</Message>)
            : null

        return (
            <DialogContainer>
                <DialogHeader>
                    {t('Язык общения')}
                </DialogHeader>
                <DialogBody>
                    <div className={styles.wrapper}>
                        {content}
                        <div className={styles.error}>{languageNotSelectedMessage}</div>
                    </div>
                </DialogBody>
                <DialogFooter>
                    <ButtonGroup>
                        <Button
                            isJustified
                            isDisabled={this.state.isLanguageNotSelected}
                            onClick={this.updateLanguages}>
                            {t('Сохранить')}
                        </Button>
                        <Button isJustified onClick={this.props.hideDialog}>{t('Закрыть')}</Button>
                    </ButtonGroup>
                </DialogFooter>
            </DialogContainer>
        )
    }
}

LanguagesDialog.defaultProps = {
    isOpen: false,
    languagesMap: {},
    hideDialog: () => {},
    updateLanguages: (languages) => {},
}

export default LanguagesDialog